// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".auth-form__link {\n  color: #fff;\n}\n\n.auth-form__link:hover {\n  opacity: .85;\n}", "",{"version":3,"sources":["webpack://src/blocks/auth-form/__link/auth-form__link.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd","sourcesContent":[".auth-form__link {\n  color: #fff;\n}\n\n.auth-form__link:hover {\n  opacity: .85;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
